import { $http } from '../request'
import Qs from 'qs'
import domain from '../../server-config/domain.config'
import { getBiPropertiesAttr } from '@/plugins/bi-sa.client'

/** 获取数据统计 */
export const getPersonalCount = () => {
  return $http.get({
    url: '/personal-center-count'
  })
}

/** 获取积分 */
export const getRewards = () => {
  return $http.get({
    url: '/rewards'
  })
}

/** 获取钱包参数 */
export const getWalletParam = () => {
  return $http.get({
    url: '/wallet-param',
    loading: true
  })
}

/** 获取用户手机号和邮箱 */
export const getAccountContacts = () => {
  return $http.get({
    url: '/account/contacts',
    loading: true
  })
}

/** 获取积分明细 */
type rewardsLogParams = {
  lastId: number,
  limit: number
}
export const getRewardsLog = (params: rewardsLogParams) => {
  return $http.get({
    url: `/rewards-log?lastId=${params.lastId}&limit=${params.limit}`,
    loading: true
  })
}

/** 发送手机号验证码 */
export interface SmsParams {
  type: number,
  PfxRegion: number | string,
  phone: number | string,
  phoneRegionId?: number | string
}
export const postSmsCode = (params: SmsParams) => {
  return $http.post({
    url: '/sms/code',
    loading: true,
    body: Qs.stringify(params),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    }
  })
}

/** 发送 WhatsApp 验证码（账号绑定 validateType=2） */
export interface WhatsAppCodeParams {
  type: number
  PfxRegion: number | string
  phone: number | string
  phoneRegionId?: number | string
}
export const postWhatsAppCode = (params: WhatsAppCodeParams) => {
  const headers: Record<string, string> = {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
  if (params.PfxRegion) {
    headers['Pfx-Region'] = String(params.PfxRegion)
  }
  return $http.post({
    url: '/whatsapp/code',
    loading: true,
    body: Qs.stringify(params),
    headers
  })
}

/** 手机号绑定 */
export interface AccountPhoneParams {
  code: number,
  sn: number | string,
  phone: number | string
  phoneRegionId?: number | string
  verifyChannel?: string,
  type?: string
}
export const postAccountPhone = (params: AccountPhoneParams) => {
  return $http.post({
    url: '/account/phone',
    loading: true,
    params: params
  })
}
export const postAccountWhatsApp = (params: AccountPhoneParams) => {
  return $http.post({
    url: '/account/bind-whatsapp',
    loading: true,
    params: params
  })
}

/** 发送邮箱验证码 */
export interface EmailParams {
  type: number,
  email: number | string
}
export const postEmailCode = (params: EmailParams) => {
  return $http.post({
    url: '/email/code',
    loading: true,
    body: Qs.stringify(params),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    }
  })
}

/** 设置新密码 */
export interface PasswordParams {
  password: string,
  confirmPassword: string,
  verificationType: any,
  code: number | string,
  sn: string
}
export const postPassword = (params: PasswordParams) => {
  return $http.put({
    url: '/password',
    loading: true,
    body: Qs.stringify(params),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    }
  })
}

/** 邮箱绑定 */
export interface AccountEmailParams {
  code: number,
  sn: number | string,
  email: string
}
export const postAccountEmail = (params: AccountEmailParams) => {
  return $http.post({
    url: '/account/email',
    loading: true,
    params: params
  })
}

/** About */
export const getAbout = () => {
  return $http.get({
    url: '/operation/config/introduction?configType=about',
    loading: true
  })
}


export interface IVoucherLimiter {
  categoryIds: number[];
  skuIds: any[];
  storeIds: any[];
  listingIds: any[];
  logisticsTypes: any[];
  deliveryMethods: any[];
}
export interface Voucher {
  // 金额
  amount: number,
  remainNumber: number,
  // 开始时间
  startDate: string,
  name: string,
  storeName?: string,
  // 结束时间
  endDate: string,
  // 券ID
  genId: number | string,
  // 券使用类型 平台、店铺
  ownerType: number,
  // 限制类型 包括1、全品类；2、限制品类；3、限制Listing
  limitType: number,
  // 券类型 1、普通券， 2、补偿券, 3、运费券
  voucherType: 1 | 2 | 3,
  // 是否有使用门槛
  isLimit: boolean,
  // 门槛金额
  limitBillAmount: number
  // 是否已领取
  isEarned?: boolean,
  // 是否为已进入提醒范围的到期提醒券
  isImportant?: boolean,
  voucherId: number,
  // 券状态 1 未使用；2 已使用；3 已过期；4 已失效
  status?: number,
  // 店铺ID
  storeId?: number
  usageScope: string
  notice: string
  limiter: IVoucherLimiter
}
export interface IInvalidVoucher extends Voucher {
  reasons: string[]
}
/** 领券中心 */
export const getVoucherGens = (skip:number, limit:number) => {
  return $http.get({
    url: `/voucher-gens?skip=${skip}&limit=${limit}`
  })
}

/** 店铺优惠券获取 */
export const getVoucherGensByStoreId = (storeId: number) => {
  return $http.get({
    url: `/voucher-gens?skip=0&limit=100&storeId=${storeId}`
  })
}

/** 我的优惠券 */
export const getMyVoucher = (lastId:number, limit:number) => {
  return $http.get({
    url: `/my-vouchers?lastId=${lastId}&limit=${limit}`,
  })
}

export const getVoucherDetailById = (vid: number, server = false) => $http.get({ url: `/given-voucher-gens?genIds=${vid}`, server }).then((r: any) => r.data)

/** 领券场景埋点枚举 */
export type ReceiveScene =
  | 'PRODUCT_DETAIL'        // 商详页
  | 'SHOP_PAGE'             // 店铺页
  | 'VOUCHER_RECEIVE_URL'   // 领券URL页面
  | 'BUYER_SELLER_CHAT'     // 买卖聊天
  | 'VOUCHER_CENTER'        // 代金券中心
  | 'SHOPPING_CART'         // 购物车

/** 领取优惠券 */
export const postVoucher = (
  params: { genId: number | string; receiveScene?: ReceiveScene },
  loading: boolean
) => {
  const { genId, receiveScene } = params
  const { $sensorsConfig, $getExternalLastTrafficSource } = useNuxtApp() as any

  const sensorProperty: IAnyObject = {}
  Object.keys($sensorsConfig?.customEventCommonAttr || {}).forEach((key: string) => {
    if (key !== 'user_id') {
      const val = $sensorsConfig?.customEventCommonAttr[key] === undefined ? '' : $sensorsConfig?.customEventCommonAttr[key]
      sensorProperty[key] = val
    }
  })

  const config = { ...sensorProperty, ...$getExternalLastTrafficSource() }
  const biPropertiesAttr: any = getBiPropertiesAttr()
  biPropertiesAttr.sensor_properties = config

  return $http.post({
    url: '/voucher',
    params: {
      genId,
      ...(receiveScene ? { trackingInfo: JSON.stringify({ receiveScene }) } : {})
    },
    loading,
    headers: {
      'Sensor-properties': JSON.stringify(biPropertiesAttr)
    }
  })
}

export const getShippingAddress = (loading: boolean = true) => $http.get({ url: '/shipping-address', loading }).then((r: any) => r.data)
// 2023年7月12日10:16:33  废弃
// export const selectShippingAddress = (selectedId: number) => $http.patch({ url: '/select-shipping-address', body: { selectedId }, loading: true })

export const setDefaultAddressById = (defaultId: number, loading: boolean = true) => $http.patch({ url: '/default-shipping-address', body: { defaultId }, loading })

export const delAddressById = (addrId: number) => $http.delete({ url: `/shipping-address/${addrId}`, loading: true })

export const getAreaById = (aid: number) => $http.get({ url: `/area/${aid}/areas`, loading: true }).then((r:any) => r.data)

export const getPickStations = (areaId: number) => $http.get({ url: `/area/${areaId}/pickup-stations`, loading: true }).then((r:any) => r.data)

export interface IAddressParams {
  name: string;
  familyName: string;
  givenName: string;
  phone: number;
  areaId: number;
  isDefault: number;
  address: string;
  pickupStationId: number;
  addressId?: number;
}
export const updateAddress = (params: IAddressParams) => $http.patch({ url: '/shipping-address', params }).catch((e: any) => {
  showToast(e.msg || e.message)
  return Promise.reject(e)
})
export const createdAddress = (params: IAddressParams) => $http.post({ url: '/shipping-address', params }).then((r: any) => r.data).catch((e: any) => {
  showToast(e.msg || e.message)
  return Promise.reject(e)
})

export const getShipingCartTotal = () => $http.get({ url: '/cart/items-count' }).then((r: any) => r.data)


// 刷新令牌
export const refreshToken = () => {
  const userInfo = useUserInfo().value as IUserInfo

  return $http.post({
    url: '/session/token',
    // method: 'post',
    loading: false,
    body: { refreshToken: userInfo.refreshToken }
  })
}

export const getOldKWapKongToken = async() => {
  const cacheOldToken = localStorage.getItem('cache_old_token')

  if(cacheOldToken) {
    try {
      const _cacheData = JSON.parse(cacheOldToken)
      
      if(_cacheData.long_token) {
        return _cacheData
      }
    } catch(e) {
      console.error('JSON.parse(cacheOldToken): ', e)
    }
  }

  const data = await $http.get({
    url: `${domain.AFTERSALE_KONG_URL}/aftersale/v1/ke/lite-buyer/old_order_status`,
    loading: false
  }).then((r: any) => r.data)

  localStorage.setItem('cache_old_token', JSON.stringify(data))

  return data
}

export const getAccountStateLite = () => $http.get({
  url: `${domain.BASE_URL}/account-cancellation-state`,
  loading: true
}).then((r: any) => r.data)

export const accountApplicationLite = (data: any) => $http.post({
  url: `${domain.BASE_URL}/account-cancellation-application`,
  loading: true,
  body: data
})

export const cancelAccountApplicationLite = () => $http.post({
  url: `${domain.BASE_URL}/cancel-account-cancellation-application`,
  loading: true
})

export const getUserProfile = () => $http.get({ url: `${domain.BASE_URL}/me/profile`, loading: false }).then((r: any) => r.data)
// KForce 修改个人身份信息
export const putBusinessEntities = (params: any) => {
  return $http.put({
    url: '/baseuser/v1/users/business-entities',
    loading: true,
    body: params
  })
}
// KForce 获取申请信息
export const getSalesAgent = () => $http.get({
  url: `/marketing/v1/agent/sales-agent?isQueryIdentity=true`,
  loading: true
}).then((r: any) => r.data)
// KForce 获取申请信息
export const getSalesAgentAp = () => $http.get({
  url: `/marketing/v1/agent/sales-agent`,
  loading: true
}).then((r: any) => r.data)
// 申请KForce
export const postBusinessEntities = () => {
  return $http.post({
    url: '/marketing/v1/agent/sales-agent',
    loading: true,
    body: {}
  })
}
// 重新申请KForce
export const patchBusinessEntities = (agent_id: number) => {
  return $http.patch({
    url: `/marketing/v1/agent/sales-agent/${agent_id}`,
    loading: true,
    body: {}
  })
}
// 获取KForce首页佣金数据概览
export const getKForceHomeStatistics = (params: { createdStartTime: string, createdEndTime: string }) => $http.get({
  url: `/marketing/v1/agent/commission-orders/statistics`,
  loading: true,
  params
}).then((r: any) => r.data)
// 获取佣金单管理页数据概览
export const getKForceOrderStatistics = (params: { createdStartTime: string, createdEndTime: string }) => $http.get({
  url: `/marketing/v1/agent/commission-orders-status/statistics`,
  params,
  loading: true
}).then((r: any) => r.data)
// 获取佣金单列表
export const getKForceCommissionOrders = (params) => $http.get({
  url: `/marketing/v1/agent/commission-orders`,
  loading: true,
  params
}).then((r: any) => r.data)
// 获取佣金单状态变更列表
export const getKForceCommissionOrdersChangeLogs = (commission_order_id: number) => $http.get({
  url: `/marketing/v1/agent/commission-order/${commission_order_id}/change-logs`,
  loading: true
}).then((r: any) => r.data)
// 获取钱包余额和是否开通
export const getWallet = () => $http.get({
  url: `/wallet`,
  loading: true
}).then((r: any) => r.data)
